<template>
  <div>
    <div class="main">
      <div class="form-row-parse">
        <div class="form-input-parse" @change="showVillage">
          <label for="name-input">Поселок</label>
          <select id="name-input" v-model="idVillage">
            <option
              v-for="(village, key) in villages"
              :value="village.ID"
              :key="key"
            >
              {{ village.NAME }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-row-parse">
        <div v-show="info">{{ info }}</div>
      </div>
    </div>
    <div class="map_select_element">
      <div class="data_select_element" v-show="selectElementOb">
        <button @click="closeSelectData" class="close_select_data">X</button>
        <pre>{{ dataSelectElement | pretty }}</pre>
      </div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
        @map-was-initialized="firstMapInit"
      >
        <ymap-marker
          v-for="(item, index) in showVillageBound"
          :coords="item.coordinates"
          :marker-type="item.type"
          :properties="{ id: item.id }"
          :options="overlayVillage"
          :marker-id="index"
          v-bind:key="index + 'village'"
        />
        <ymap-marker
          v-for="(item, index) in plants"
          :coords="item.coordinates"
          :marker-type="item.type"
          :options="overlayPlant"
          :properties="{ data: item.data, id: item.id, delete: 'N' }"
          :marker-id="index"
          :key="index + 'plant'"
          @click="clickPolygon"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "AddVillageCoord",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      info: null,
      map: false,
      plantsData: {},
      landsChoseToEdit: [],
      landsDeleted: [],
      selectElementOb: false,
      fillColor: "#307c0d",
      fillColorChosed: "#7c0d16",
      fillColorSelect: "#b9b9b9",
      idVillage: null,
      idDistrict: null,
      idRegion: null,
      villages: [],
      districts: [],
      regions: [],
      plants: [],
      showVillageBound: [],
      selectVillageCenter: false,
      url: config.backend_url,
      coordsCenter: [55.755819, 37.617644],
      overlayVillage: {
        fillColor: "#7c270d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      },
      overlayPlant: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      }
    };
  },
  computed: {
    dataSelectElement: function() {
      return this.selectElementOb
        ? this.selectElementOb.properties.get("data")
        : false;
    }
  },
  methods: {
    clickPolygon(e) {
      let element = e.get("target");
      if (this.selectElementOb === element) {
        element.options.set("fillColor", this.fillColor);
        element.properties.set("selected", "N");
      } else {
        this.unselectElements();
        element.options.set("fillColor", this.fillColorSelect);
        element.properties.set("selected", "Y");
        this.$emit("select", {
          data: this.plants[element.properties._data.markerId],
          village_id: this.idVillage
        });
      }
    },
    closeSelectData() {
      this.selectElementOb.properties.set("selected", "N");
      this.selectElementOb.options.set("fillColor", this.fillColor);
      this.selectElementOb = false;
    },
    unselectElements() {
      let self = this;
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          if (ob.properties.get("selected") === "Y") {
            ob.properties.set("selected", "N");
            ob.options.set("fillColor", self.fillColor);
          }
        });
      });
    },
    firstMapInit: function(map) {
      this.map = map;
    },
    getVillages: function() {
      let self = this;
      let data = {
        url: self.url + "villages/get/",
        filter: {
          /*MANAGE_COMPANY: self.idDistrict*/
        },
        method: "POST"
      };
      this.plants = [];
      this.$store
        .dispatch("query/sendRequest", data)
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
            let elementsData = [];
            for (const [key, value] of Object.entries(data)) {
              let coord = JSON.parse(value.GEO_COORD);
              let valueCoord = {};
              coord.forEach(function(val) {
                valueCoord.name = value.NAME;
                valueCoord.type = val.type;
                valueCoord.id = parseInt(value.ID);
                valueCoord.coordinates = val.coordinates;
                elementsData.push(valueCoord);
              });
            }
            self.showVillageBound = elementsData;
          }
        })
        .then(function() {
          setTimeout(function() {
            self.map.setBounds(self.map.geoObjects.getBounds(), {
              checkZoomRange: true,
              duration: 2000
            });
          }, 500);
        });
    },
    showVillage: function() {
      let self = this;
      let village = this.villages[this.idVillage];
      let geoCoord = JSON.parse(village.GEO_COORD);
      this.selectVillageCenter = geoCoord[0].coordsCenter;
      this.showVillageBound = geoCoord;
      this.mapSetBounds();

      let data = {
        url: self.url + "plots/get/",
        filter: { VILLAGE: this.idVillage },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          let elementsData = [];
          for (const [key, value] of Object.entries(data)) {
            let coord = JSON.parse(value.COORDINATES);
            let valueCoord = {};
            valueCoord.name = value.KADASTR;
            valueCoord.type = "Polygon";
            valueCoord.id = parseInt(value.ID);
            valueCoord.coordinates = [];
            valueCoord.coordinates.push(coord);
            elementsData.push(valueCoord);
          }
          self.plants = elementsData;
        }
      });
      /*.then(function() {
          setTimeout(function() {
            self.map.setBounds(self.map.geoObjects.getBounds());
          }, 1000);
        });*/
    },
    mapSetBounds() {
      if (this.selectVillageCenter) {
        let self = this;
        let villageOb = false;

        this.map.geoObjects.each(function(geoCollection) {
          geoCollection.each(function(ob) {
            if (ob.properties.get("id") === parseInt(self.idVillage)) {
              villageOb = ob;
            }
          });
        });

        if (villageOb) {
          let oldCenter = this.map.getCenter();
          let newCenter = this.selectVillageCenter;
          let duration = 1000;

          this.map
            .panTo([oldCenter, newCenter], {
              checkZoomRange: true,
              duration: duration
            })
            .then(() => {
              self.map.setBounds(villageOb.geometry.getBounds());
            });
        }
      }
    }
  },
  created() {
    this.getVillages();
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    }
  }
};
</script>

<style>
.map_select_element .ymap-container {
  width: 500px;
  height: 500px;
  display: flex;
}
</style>
